import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ExpandMore } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  headings: {
    fontSize: '30px',
    fontWeight: 200,
  },
  reportSection: {
    border: 'none',
    borderRadius: '0',
    marginBottom: '16px',
    padding: '14px 18px',
  },
}));

const DashDetailsWrapper = ({ backgroundColor, expandColor, heading1, heading2, children, overflowX }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);
  const isReportExport = window.location.pathname.includes('/report-export/');

  if (isReportExport) {
    const exportBackground = backgroundColor || '#fff';
    const isDarkBackground = ['#254157', '#1F2937', '#111827', 'black', '#000'].includes(
      (exportBackground || '').toLowerCase(),
    );

    return (
      <Box
        className={classes.reportSection}
        data-report-section="true"
        style={{
          overflowX: overflowX ? 'auto' : 'unset',
          backgroundColor: exportBackground,
          color: isDarkBackground ? '#F3F4F6' : '#111827',
          breakInside: 'auto',
          pageBreakInside: 'auto',
        }}>
        <Box display="flex" alignItems="center" width="100%" marginBottom="8px" flexWrap="wrap" gridGap="12px">
          <Typography
            variant="h4"
            className={classes.headings}
            style={{ color: heading1?.color || (isDarkBackground ? '#F9FAFB' : '#111827') }}>
            {heading1.text}
          </Typography>
          {heading2 && (
            <Typography
              variant="h4"
              className={classes.headings}
              style={{ color: heading2?.color || (isDarkBackground ? '#D1D5DB' : '#374151') }}>
              {heading2.text}
            </Typography>
          )}
        </Box>
        <Box>{children}</Box>
      </Box>
    );
  }

  return (
    <Box style={{ backgroundColor, overflowX: overflowX ? 'scroll' : 'unset' }}>
      <Accordion
        style={{ padding: '10px 15px', backgroundColor: 'transparent' }}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}>
        <AccordionSummary expandIcon={<ExpandMore fontSize="large" style={{ color: expandColor }} />}>
          <Box display="flex" alignItems="center" width="95%">
            <Typography variant="h4" className={classes.headings} style={{ color: heading1.color }}>
              {heading1.text}
            </Typography>
            {heading2 && (
              <Typography variant="h4" className={classes.headings} style={{ color: heading2.color, marginLeft: '32%' }}>
                {heading2.text}
              </Typography>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default DashDetailsWrapper;
